export enum SortDirections {
  Ascending = 0,
  Descending = 1,
  None = 3,
}